

/**
 * Base javascript functionality
 * Only put functionality in here that is used GLOBALLY
 **/

/**
 * On page load
 **/
$(document).ready( function(){
    PageSetup(); 
});

/**
 * On ajax completion
 **/
$(document).ajaxComplete(function(){
    ProductEnquiries();
    ProductSlider();
    RunSlider();
    ChangeByArrows();
    Enquiries();
});


window.onload = function() {
    document.body.className += " loaded";
}


function PageSetup(){
    MegaMenu();
    MobileNav();
    SecondaryNav();
    CheckImageSizes();
    SquareElements();
    SocialShare();
    RunSlider();
     if($('.slider.autoslide').length){
        AutoSlide();
    }
    Popups();
    ProductEnquiries();
    ProductSlider();
    MaterialLightBox();
    Enquiries();
    ToggleImageCaptions();

    $('.sub-nav').css('cursor','pointer');

     if( $('.togglable').length ){
        ToggleContent();
    }
}

$(window).on("resize", function(evt){
	CheckImageSizes();
});


function CheckImageSizes(){
	$(document).find('.image.responsive').each(function(){
		var image = $(this);
		var sizes = image.attr('data-sizes');
		var url = null;

		try {
			sizes = JSON.parse(sizes);
		} catch (error) {
			console.error(error);
			return false;
		}

		for (var i = 0; i < sizes.length; i++){
			if (sizes[i].max === undefined || image.outerWidth() <= sizes[i].max){
				url = sizes[i].url;
				break;
			}
		}

		if (url){
			image.css('background-image', 'url('+url+')');
		}
	});
}



function RunSlider(){
    if($('.slider-nav').length){
        ChangeByNav();
    }
    else{
        ChangeByArrows();
    }
}

function ChangeByNav(){
    // when slider nav button is clicked
    $(document).on('click', '.slider-nav a:not(.current)', function(){

        // change the slide
        ChangeSlideAndUpdateNav($(this));

        // stop the autoslide, if it's been started
        if($('.slider.autoslide').length){
            clearInterval(timer);
        }

    });
}

function ChangeByArrows(){
    // when slider nav button is clicked
    $(document).on('click', '.slider-nav-arrow', function(){

        var current_slide = $(this).parents('.slider').children('.slide.current');
        var direction = $(this).data('direction');

        // if next has been clicked
        if(direction == 'next'){
            // determine the next slide
            if(current_slide.next('.slide').length){
                // if there's a slide after the current one, target it
                var next_slide = current_slide.next('.slide');
                
            }else{
                // otherwise we're at the start of the list; loop back to the first slide
                var next_slide = $(this).parents('.slider').children('.slide').first();
            }

        }

        // if prev has been clicked
        else{

            // determine the next slide
            if(current_slide.prev('.slide').length){
                // if there's a slide before the current one, target it
                var next_slide = current_slide.prev('.slide');
                
            }else{
                // otherwise we're at the end of the list; loop back to the last slide in the list
                var next_slide = $('.slide').last();
            }
        }

        // change the slide
        ChangeSlide(current_slide, next_slide);

        clearInterval(timer);

    });
}

/**
 * Fade out the current slide and fade in the next one
 * @param {slide obj} current_slide [the slide to be faded out]
 * @param {slide obj} next_slide    [the slide to be faded in]
 */
function ChangeSlide(current_slide, next_slide){

    // update slides
    current_slide.stop().fadeOut(1500).removeClass('current');
    next_slide.stop().fadeIn(1500).addClass('current');

}

/**
 * Change to slide corresponding to the nav button clicked
 * @param {button obj} trigger [the trigger button]
 */
function ChangeSlideAndUpdateNav(trigger){

    // get stuff
    var current_slide = $('.slide.current');
    var id = trigger.data('slide');
    var next_slide = $('#slide-' + id);
    
    // update slides
    current_slide.stop().fadeOut(1500).removeClass('current');
    next_slide.stop().fadeIn(1500).addClass('current');
    
    // update nav
    $('.slider-nav a').removeClass('current');
    trigger.addClass('current');

}

function AutoSlide(){

    timer = setInterval(
        
        function(){

            if($('.slider-nav').length){
                // get the current slide
                var current_button = $(document).find('.slider-nav a.current').first();

                // determine the next slide
                if(current_button.next().length){
                    // if there's a slide after the current one, target it
                    var trigger = current_button.next();
                }else{
                    // otherwise we're at the end of the list; loop back to the first slide
                    var trigger = $('.slider-nav a').first();
                }
                //console.info(trigger);
                ChangeSlideAndUpdateNav(trigger);
            }
            else{

                // get the current slide
                var current_slide = $('.slide.current');

                // determine the next slide
                if(current_slide.next('.slide').length){
                    // if there's a slide after the current one, target it
                    var next_slide = current_slide.next('.slide');
                    
                }else{
                    // otherwise we're at the start of the list; loop back to the first slide
                    var next_slide = $('.slide').first();
                }

                ChangeSlide(current_slide, next_slide);

            }
        },
        5000
    );
}





/**
 * social share
 * get details from link attributes and construct popup
 **/
function SocialShare(){
    
    // On clicks of media icons
    $('.share-popup').click(function(){
        var sharelink = $(this).attr('data-sharelink');
        var url = $(this).attr('data-url');
        window.open(sharelink + url,'_blank','height=400,width=600,menubar=0,resizable=1,toolbar=0,location=0',true);
    });
}

function SquareElements(){
    $('.square').each(function(){
        var width = $(this).outerWidth();
        $(this).height(width);
    });
}

function MobileNav(){
    $('.hamburglar').click( function(){
        $('html, body').toggleClass('no-scroll');
        $(this).toggleClass('open');
        $('.mainnav').toggleClass('open');
    });
}


function SecondaryNav(){

    var toggle = $('span.second-nav-plus');
    toggle.click( function(){
        $(this).toggleClass('open');
        $('.secondary').toggleClass('open');
    });

    // wallpaper filter specific functionality
    var wrapper = $('.wallpaper-filter-wrapper');
    var close = wrapper.find('.close');
    var scroll_to = toggle.parent('h3');

    close.click( function(){
        wrapper.slideUp(200, function(){
            $(this).removeAttr('style');
            $(this).toggleClass('open');

        });
        if(scroll_to.length){
            $('html, body').animate({
                scrollTop: scroll_to.offset().top
            }, 200);
        }
    });
}


$(window).resize(function(){
    var windowHeight    = $(window).height();
    $('nav.mobnav').height(windowHeight);
    SquareElements();
});

function MegaMenu(){

    // on click on menu item
    $('.menu-link.has-mega-menu').click(function(e) {
        
        // don't follow link
        e.preventDefault();

        if( $(this).hasClass('inactive') ){

            // first, close any open megamenus
            $('.menu-link.has-mega-menu').removeClass('active').addClass('inactive');;
            $('.mega-menu').removeClass('active');

        }

        // stop overriding inline accent-color
        $(this).toggleClass('inactive');

        // toggle relevant mega menu
        $(this).siblings('.mega-menu').toggleClass('active');

     });

    // on click of close button
    $('.mega-menu .close').click(function(){

        // get elements we need
        var megamenu = $(this).parent('.mega-menu');
        var menuitem = megamenu.siblings('.menu-link');

        // toggle them
        megamenu.toggleClass('active');
        menuitem.toggleClass('inactive');

    });

}

/**
 * Product enquiries
 */
function Popups(){
    $('.popup-trigger').click(function(){
       // $('.popup').toggleClass('hide');
        $('.popup').fadeIn(100);
    });

    $('.popup .close').click(function(){
        //$('.popup').toggleClass('hide');
        $('.popup').fadeOut(100);
        $('.popup .popup-content').html('');
    });
}

/**
 * Product enquiries
 */
function ProductSlider(){

    var popup = $('.popup').first();
    var target = popup.find('.popup-content');

    $('.products .product-slider').click(function(){

        // fetch form
        $.ajax({
            url: $(this).data('url') + '/ProductSlider/',
            method: 'POST',
            data: 'SlideID=' + $(this).data('id') + '&ObjID=' + $(this).data('objid'),
            success: function( response ){
                target.html( response );
            },
            error: function( response ){
                alert('There was a problem, please try again');
            }
        });
    });

}

/**
 * Product enquiries
 */
function ProductEnquiries(){

    var popup = $('.popup').first();
    var target = popup.find('.popup-content');

    $('.product-enquiry').click(function(){

        // var data = [];
        // data['id'] = $(this).data('id');

        var url = $(this).data('url') + '/RenderedProductEnquiryForm/';
        if($(this).data('id')){
            url += '?ProductID=' + $(this).data('id');
        }
        if($(this).data('type')){
            url += '&ProductType=' + $(this).data('type');
        }
        console.info(url);

        // fetch form
        $.ajax({
            url: url,
            //data: data.serialize(),
            method: 'GET',
            success: function( response ){
                target.html( response );
            },
            error: function( response ){
                alert('There was a problem, please try again');
            }
        });
    });

    $('.delivery-information').click(function(){
        var deliveryInfo = $(this).attr('data-delivery-info');

		// display text
        target.html(deliveryInfo);
	});

    $('#Form_ProductEnquiryForm .submit').click(function(){

        var form = $(this).closest('form');
        var valid = true;
        var required_fields = [
            form.find('input[name=Name]'),
            form.find('input[name=Email]'),
            form.find('textarea[name=Message]')
        ];

        // check required fields contain something.
        // if not, set valid to false and add error classes
        $.each(required_fields, function(key, field){
            if( !field.val() ){
                valid = false;
                field.addClass('required error');
            }
        });

        // if all required fields are not valid, show a message
        if( !valid ){
            alert('Please complete all required fields');
        }
        else {
            // otherwise, submit the form
            $.ajax( {
                url: form.attr('action') + 'SubmitProductEnquiryForm/',
                type: form.attr('method'),
                data: form.serialize(),
                success: function(response){
                    json = jQuery.parseJSON( response );
                    if(json.HTML){
                        target.html(json.HTML);
                    }
                    
                },
                error: function( response ){
                    alert('There was a problem, please try again');
                }
            });

        }

    });

    /**
     * Handle clearing of error classes from required inputs
     */
    $('#Form_ProductEnquiryForm input.text, #Form_ProductEnquiryForm textarea').change(function(){
        if($(this).hasClass('required error')){
            if($(this).val()){
                $(this).removeClass('required error');
            }
        }
    });

}

/**
 * Material popup
 */
function MaterialLightBox(){

    var popup = $('.popup').first();
    var target = popup.find('.popup-content');


    $('.popup-material').click(function(){

    var html = '<img src="'+$(this).attr('data-url')+'" />';

        target.html(html);

    });    

}

/**
 * Product popup
 */
function ProductLightBox(){

    var popup = $('.popup').first();
    var target = popup.find('.popup-content');


    $('.popup-product').click(function(){

    // var html = '<img src="'+$(this).attr('data-url')+'" />';
    // target.html(html);

    });    

}



/**
 * Price enquiries
 */
function Enquiries(){

    var popup = $('.popup').first();
    var target = popup.find('.popup-content');

    $('.price-enquiry').click(function(){
        // fetch form
        $.ajax({
            url: $(this).data('url') + '/RenderedEnquiryForm/',
            method: 'GET',
            success: function( response ){
                target.html( response );
            },
            error: function( response ){
                alert('There was a problem, please try again');
            }
        });
    });

    $('#Form_EnquiryForm .submit').click(function(){
        // alert('hi');
        var form = $(this).closest('form');
        var valid = true;
        var required_fields = [
            form.find('input[name=Name]'),
            form.find('input[name=Email]'),
            form.find('textarea[name=Message]')
        ];

        // check required fields contain something.
        // if not, set valid to false and add error classes
        $.each(required_fields, function(key, field){
            if( !field.val() ){
                valid = false;
                field.addClass('required error');
            }
        });

        // if all required fields are not valid, show a message
        if( !valid ){
            alert('Please complete all required fields');
        }
        else {
            // otherwise, submit the form
            $.ajax( {
                url: form.attr('action') + 'SubmitEnquiryForm/',
                type: form.attr('method'),
                data: form.serialize(),
                success: function(response){
                    json = jQuery.parseJSON( response );
                    console.log();
                    if(json.HTML){
                        target.html(json.HTML);
                    }
                    
                },
                error: function( response ){
                    alert('There was a problem, please try again');
                }
            });

        }

    });

    /**
     * Handle clearing of error classes from required inputs
     */
    $('#Form_EnquiryForm input.text, #Form_EnquiryForm textarea').change(function(){
        if($(this).hasClass('required error')){
            if($(this).val()){
                $(this).removeClass('required error');
            }
        }
    });
}

/**
** Credits on banner
*/

function ToggleImageCaptions(){
    
    $('.credited-image .toggle').stop().click(function(){
        
        var target = $(this).siblings('.details');
        
        if($(this).hasClass('fadein')){
            target.fadeIn(100);
        }else{
            target.fadeOut(100);
        }
        
        $(this).toggleClass('fadein fadeout');
        
    });
    
}


function ToggleContent(){
    $('.toggle-button').click(function(){
        $(this).parent('.togglable').children('.togglable-content').toggleClass('open');
        $(this).toggleClass('open');
    });
}